<template>
  <div class="folders">
    <!-- <h2>Folders (10)</h2> -->
    <div
      @click="showmodel = isSelectedIndex = false"
      :class="showmodel ? 'close-option show_overlay' : 'close-option'"
    ></div>
    <ul class="folder-listing">
      <li
        class="list"
        v-for="(getUserFile, index) in getUserFile.folder"
        :key="index"
      >
        <div class="inner" @click="redirect(getUserFile.folder_id)">
          <span class="icon">
            <img src="../assets/images/ic_folder.svg" alt />
          </span>
          <div class="text">
            <p>{{ getUserFile.folder_name }}</p>
            <span
              >{{ getUserFile.file_count }}Files | {{ getUserFile.date }}</span
            >
          </div>
        </div>
        <div class="dot-icon">
          <span class="option-icon" @click="active(index)">
            <img src="../assets/images/ic_dots.svg" alt />
          </span>
          <ul
            :class="
              isSelectedIndex === index
                ? 'option-list show-option'
                : 'option-list'
            "
          >
            <li class="rename-file" @click="renamefolder(index)">
              <span class="opt-icon">
                <img src="../assets/images/ic_folder.svg" alt />
              </span>
              Rename Folder
            </li>
            <li class="move-file" @click="moveFolderFrom(index)">
              <span class="opt-icon">
                <img src="../assets/images/ic_move.svg" alt />
              </span>
              Move File
            </li>
            <li class="delete-file" @click="deleteFolder(index)">
              <span class="opt-icon">
                <img src="../assets/images/ic_trash.svg" alt />
              </span>
              Delete Folder
            </li>
          </ul>
        </div>
      </li>
      <li class="img-file">
        <div
          class="img icons"
          :class="{ 'select-img': selectedFiles[index] }"
          v-for="(getUserFile, index) in getUserFile.Data"
          :key="index"
        >
          <component
            :url="getUserFile.data_url"
            :is="findMimeTypeViewer(index)"
          ></component>
          <span class="select-icon" @click="selectFiles(index)"></span>
          <span>{{ getUserFile.data_name }}</span>
        </div>
      </li>
      <loader91 v-if="isLoading"></loader91>
    </ul>
    <!-- add popup -->
    <div class="add-popup" :class="{ active: showAddPopup }">
      <ul>
        <li class="create-folder">
          <img src="../assets/images/ic_folder.svg" alt />
          <span @click="showCreate">Create Folder</span>
        </li>
        <li>
          <img src="../assets/images/ic_upload.svg" alt="" />

          <span class="upload-file">
            Upload 
            <input
              type="file"
              id="myFile"
              multiple="multiple"
              @change="uploadFile"
              ref="file"
              name="upload"
            />
            <!-- <button @click="uploadFile">Upload</button> -->
          </span>
        </li>
      </ul>
    </div>

    <span class="add-btn" @click="addbtn">
      <img
        src="../assets/images/ic_add.svg"
        :class="{ rotate: showRotate }"
        alt
      />
    </span>
    <div class="create-popup" :class="{ active: showModelCreate }">
      <div class="content animated fadeInUp faster">
        <h2>Create Folder</h2>
        <label for>फोल्डर का नाम</label>
        <input
          type="text"
          v-model="fileName"
          placeholder="Create Folder Name"
        />
        <span @click="createFolder()" class="save-btn">Save</span>
        <span class="close" @click="close">
          <img src="../assets/images/cross_red.svg" alt />
        </span>
      </div>
    </div>

    <!-- Uploading Popup -->
    <div class="uploading-popup" :class="{ active: showModelUpload }">
      <div
        class="up-content animated fadeInUp faster"
        :class="{ hid: showHid }"
      >
        <h2>Uploading</h2>
        <p>आपकी डाटा अपलोड हो रहा है</p>
         <!-- <progress :value="uploadPercentage" max="100"> </progress> % {{uploadPercentage}} -->
        <div class="upload-bar">
          <div class="file-details">
            <span class="file-name">{{ image.name }}</span>
            <span :value="uploadPercentage" max="100" class="prcnt">
              {{ uploadPercentage }}
              
            </span>
            
          </div>
          <div class="line-bar">
          <!-- <progress class="grow" :value="uploadPercentage" max="100"> </progress> -->
            <span class="grow" :style="{width: uploadPercentage+'%'}" :value="uploadPercentage" max="100"></span>
          </div>
        </div>
        <span class="cancel-btn" @click="showUpload">Cancel</span>
      </div>
      <!-- Cancel Uploading -->
      <div
        class="cancel-uploading animated fadeInUp faster"
        :class="{ show: showShow }"
      >
        <h2>Cancel Uploading</h2>
        <p>Are you sure want to cancel ?</p>
        <div class="btn">
          <span class="c-yes" @click="CancelUpload">Yes</span>
          <span class="c-no" @click="notCancelUpload">No</span>
        </div>
      </div>
    </div>

    <!-- Folder Move Popup -->
    <div class="move-popup" :class="{ active: showMove }">
      <div class="content animated fadeInUp faster">
        <h2>My Drive</h2>
        <ul>
          <li
            :class="{ active: selectingFolder[index] }"
            v-for="(getUserFile, index) in getUserFile.folder"
            :key="index"
          >
            <img src="../assets/images/ic_folder.svg" alt />
            <span>
              <p @click="moveFolderTo(index)">{{ getUserFile.folder_name }}</p>
            </span>
          </li>
        </ul>
        <div class="popup-footer">
          <span class="create-folder" @click="showCreate">
            <img src="../assets/images/ic_folder.svg"  alt /> Create Folder
          </span>
          <span @click="moveFolder()">Move Here</span>
        </div>
      </div>
      <span class="close-move-popup" @click="close()">
        <img src="../assets/images/cross_red.svg" alt />
      </span>
    </div>

    <!-----move File popup-->

    <div class="move-popup" :class="{ active: showMoveFile }">
      <div class="content animated fadeInUp faster">
        <h2>My Drive</h2>
        <ul>
          <li
            :class="{ active: selectingFolder[index] }"
            v-for="(getUserFile, index) in getUserFile.folder"
            :key="index"
          >
            <img src="../assets/images/ic_folder.svg" alt />
            <span>
              <p @click="moveFolderTo(index)">{{ getUserFile.folder_name }}</p>
            </span>
          </li>
        </ul>
        <div class="popup-footer">
          <span class="create-folder" @click="showCreate">
            <img src="../assets/images/ic_folder.svg"  alt /> Create Folder
          </span>
          <span @click="moveFile()">Move Here</span>
        </div>
      </div>
      <span class="close-move-popup" @click="close()">
        <img src="../assets/images/cross_red.svg" alt />
      </span>
    </div>

    <!-- Delete Popup -->
    <div class="delete-popup" :class="{ active: showDelete }">
      <div class="delete-content animated fadeInUp faster">
        <h2>Delete</h2>
        <p>Are you sure want to delete ?</p>
        <div class="btn">
          <span class="yes-delete" @click="CorfrimedDelete(true)">Yes</span>
          <span class="no-delete" @click="close()">No</span>
        </div>
      </div>
    </div>
    <div class="delete-popup" :class="{ active: showFileDelete }">
      <div class="delete-content animated fadeInUp faster">
        <h2>Delete</h2>
        <p>Are you sure want to delete ?</p>
        <div class="btn">
          <span class="yes-delete" @click="deleteFile()">Yes</span>
          <span class="no-delete" @click="close()">No</span>
        </div>
      </div>
    </div>

    <div class="create-popup renameFolder" :class="{ active: showmodelActive }">
      <div class="content animated fadeInUp faster">
        <h2>Rename Folder/File</h2>
        <label for>फोल्डर का नाम</label>
        <input type="text" v-model="rename" placeholder="Create Folder Name" />
        <span @click="renamFolder()" class="save-btn">Save</span>
        <span class="close" @click="close()">
          <img src="../assets/images/cross_red.svg" alt />
        </span>
      </div>
    </div>
    <footer class="option-footer" :class="{ active: showFooter }">
      <div class=" item">
        <img src="../assets/images/ic_moveBlue.svg" alt />
        <span @click="moveShowFile()">Move</span>
      </div>
      <div class="item2">
        <img src="../assets/images/ic_share.svg" alt />
        <span>Share</span>
      </div>
      <div class="item3">
        <img src="../assets/images/ic_rename.svg" alt />
        <span @click="renamefile">Rename</span>
      </div>
      <div class="item4">
        <img src="../assets/images/ic_delete.svg" alt />
        <span @click="deletefile()">Delete</span>
      </div>
      <div class="item5">
      <a :href="downloadUrl" selectedDownload>
        <img src="../assets/images/ic_download.svg" @click="downloadFile()" alt /></a>
        <span >Download</span>
        
      </div>
    </footer>
  </div>
</template>
<script>
import ImageViewer from "./FileViewer/ImageViewer";
import DefaultViewer from "./FileViewer/DefaultViewer";
import DocsViewer from "./FileViewer/DocsViewer";
import VideoViewer from "./FileViewer/VideoViewer";
import { SessionHelper, LANG } from "../utils/session";
import constant from "../utils/constant";
// import { getBase64Url } from "../utils/helper";
import axios from "axios";
import axiosCancel from 'axios-cancel';
// import AES from "crypto-js/aes"
import { mapGetters } from "vuex";
// import Crypto from 'crypto-js';
// import VueJwtDecode from 'vue-jwt-decode'
// import VueCryptojs from '../main'
export default {
  name: "folder",
  data() {
    return {
      del: name,
      activeFolderindex: "",
      activeFolderFrom: "",
      activeFolderTo: "",
      showMoveFile: false,
      showDelete: false,
      showFileDelete: false,
      showMove: false,
      uploadPercentage: 0,
      array: [],
      isLoading: true,
      showModelCreate: false,
      showShow: false,
      showHid: false,
      image: "",
      fileName: "",
      showModelUpload: false,
      showmodel: false,
      showFooter: false,
      showmodelActive: false,
      rename: "",
      showAddPopup: false,
      showRotate: false,
      folderRename: "",
      folder_name: "",
      downloadUrl: "",
      selectedFiles: [],
      selectedDownload:[],
      selectingFolder: [],
      selectedFolder: "",
      isSelectedIndex: "",
      activeFolderRenameindex: "",
    };
  },
  
  components: {
    ImageViewer,
    DefaultViewer,
    DocsViewer,
    VideoViewer,
  },
  computed: {
    ...mapGetters(["getUserFile", "getFolderId"]),
  },
  async mounted() {
    this.userFile();
    let addPopup = document.querySelector(".add-popup");
    let addimg = document.querySelector(".add-btn img");
    document.querySelector(".add-btn").addEventListener("click", () => {
      addPopup.classList.toggle("active");
      addimg.classList.toggle("rotate");
    });
  },

  methods: {
    findMimeTypeViewer(index) {
      let activeUrl = index;
      let url = this.getUserFile.Data[activeUrl].data_url;
      // console.log("url",url)
      let urlArray = url.split(".");
      let mimeType = urlArray[urlArray.length - 1];
      const imagesMimeTypes=['jpg','jpeg','png'];
      const videosMimeTypes = ["mp4", "WebM", "Ogg"];
      const docsMimeTypes = ["pptx", "doc", "docx", "pdf", "xlsx"];
      if (imagesMimeTypes.indexOf(mimeType) > -1) {
        // console.log('image');
        return "ImageViewer";
      } else if (videosMimeTypes.indexOf(mimeType) > -1) {
        return "VideoViewer";
      } else if (docsMimeTypes.indexOf(mimeType) > -1) {
        return "DocsViewer";
      }
       return "DefaultViewer"; // for default mimetypes
      // console.log('mimetype: ',mimeType);
    },
    addbtn() {
      this.showAddPopup = true;
      this.showRotate = true;
    },
    deletefile() {
      this.showFileDelete = true;
    },
    moveShowFile() {
      this.showMoveFile = true;
    },
    // Downloadfile(){

    // },
    notCancelUpload() {
      this.showHid = false;
      this.showShow = false;
      
    },
    showUpload() {
      this.showHid = true;
      this.showShow = true;
    },
    showCreate() {
      this.showModelCreate = true;
      this.showAddPopup = false;
      this.showRotate = false;
      this.showMove = false;
      this.showMoveFile = false;
    },
    CancelUpload(){
      this.showModelUpload = false;
      this.showHid = false;
      this.showShow = false;
    },
    close() {
      this.showmodelActive = false;
      // this.showmodel = false;
      this.showDelete = false;
      this.showFileDelete = false;
      this.showMove = false;
      this.showModelCreate = false;
      this.showModelUpload = false;
      this.showHid = false;
      this.showShow = false;
      this.showMoveFile = false;
    },
    active(index) {
      this.isSelectedIndex = index;
      this.showmodel = true;
    },

    async userFile() {
      let file_id = "";
      if (this.$route.params.name !== undefined) {
        let file_id_string = this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }

      await this.$store
        .dispatch("userFile", {
          headers: {
            "folder-id": file_id,
            Limit: 0,
          },
        })
        .then((data) => {
          this.isLoading = false;
        });
    },
    async uploadFile(file) {
      var _this = this;
      let file_id = "";
      if (_this.$route.params.name !== undefined) {
        let file_id_string = _this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }
      _this.showModelUpload = true;
      _this.showAddPopup = false;
      _this.showRotate = false;
      console.log(file.target.files, _this.getFolderId.newName);
      _this.image = file.target.files[0];
      const formData = new FormData();
      formData.append("myFile", _this.image);
      formData.append("folderId", file_id || "");
      console.log("file", formData);
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
						
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Auth-Id": SessionHelper.getCookie("X-Auth-Id"),
            "JWT-TOKEN": SessionHelper.getCookie("JWT-TOKEN"),
          },
          onUploadProgress: function(uploadEvent){
                _this.uploadPercentage = Math.round((uploadEvent.loaded / uploadEvent.total)*100);
							}
        })
        .then((data) => {
          console.log(data);
          _this.$toast.bottom("uploaded successfully");
          _this.showModelUpload = false;
          _this.showHid = false;
          _this.showShow = false;
          _this.isLoading = true;
          _this.userFile();
        })
        .catch((err) => {
          console.log(err);
        });

      // else {
      //   alert("File size must be smaller than 50MB")
      // }
    },
    createFolder() {
      // this.folderPath = this.$route.params.name;
      let file_id = null;
      if (this.$route.params.name !== undefined) {
        let file_id_string = this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }
      this.$store
        .dispatch({
          type: "createFolder",
          payload: {
            folder_name: this.fileName,
            folder_id: file_id,
          },
        })
        .then((data) => {
          console.log("data: ", data);
          // this.folder
          // this.folder_path=data
          this.$toast.bottom(data.message);
          this.userFile();
          this.showModelCreate = false;
          this.isLoading = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  // forceFileDownload(){
    //   const url = window.URL.createObjectURL(new Blob([this.downloadUrl]))
    //   const link = document.createElement('a')
    //   link.href = this.downloadUrl
    //   link.setAttribute('download', 'file.jpg') //or any other extension
    //   document.body.appendChild(link)
    //   link.click()
  // },
     downloadFile() {
       this.selectedFiles = [];
       this.showFooter = false;
      //  const arr = this.array.join()
        this.$toast.bottom("You can download one file at time");
    },
    renamefolder(index) {
      this.activeFolderindex = index;
      this.folderRename = null;
      this.showmodelActive = true;
    },
    renamefile() {
      this.showmodelActive = true;
      this.folderRename = 2;
      // this.getUserFile.folder[this.activeFolderindex].folder_id = null;
       console.log("data: ", this.getUserFile.Data[this.activeFolderindex].data_id);
    },
    renamFolder() {
      // this part for Folder rename in if
      if (this.folderRename === null) {
        this.$store
          .dispatch({
            type: "renameFolder",
            payload: {
              file_id: null,
              folder_name: this.rename,
              folder_id:this.getUserFile.folder[this.activeFolderindex].folder_id
            },
          })
          .then((data) => {
            console.log("data: ", data);
            this.$toast.bottom("Rename successfull");
            this.userFile();
            this.showmodelActive = false;
            this.showFooter = false;
            this.isLoading = true;
            this.getUserFile.folder[this.activeFolderindex].folder_id=null;
            this.showmodel = this.isSelectedIndex = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      // this part for File Rename in esle
      else {
         console.log("data: ", this.getUserFile.Data[this.activeFolderindex].data_id);
        this.$store
          .dispatch({
            type: "renameFolder",
            payload: {
              file_id: this.getUserFile.Data[this.activeFolderindex].data_id,
              folder_name: this.rename,
              folder_id: null,
            },
          })
          .then((data) => {
            console.log("data: ", data);
            this.$toast.bottom("Rename successfull");
            this.userFile();
            this.showmodelActive = false;
            this.showFooter = false;
            this.selectedFiles = [];
            this.isLoading = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    moveFolderFrom(index) {
      this.activeFolderFrom = index;
      this.showMove = true;
    },
    moveFolderTo(index) {
      this.$set(this.selectingFolder, index, !this.selectingFolder[index]);
      this.activeFolderTo = index;
    },
    moveFolder() {
      let fromPath = this.getUserFile.folder[this.activeFolderFrom].folder_id;
      let toPath = this.getUserFile.folder[this.activeFolderTo].folder_id;
      this.$store
        .dispatch({
          type: "moveFolder",
          payload: {
            from_folder_id: fromPath,
            to_folder_id: toPath,
          },
        })
        .then((data) => {
          console.log("data: ", data);
          this.$toast.bottom("data");
          this.userFile();
          this.showMove = false;
          this.isLoading = true;
            this.showmodel = this.isSelectedIndex = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    moveFile() {
      // console.log(
      //   "moveedd",
      //   this.getUserFile.folder[this.activeFolderTo].folder_id,
      //   this.array
      // );
      let fromPath = this.array;
      let toPath = this.getUserFile.folder[this.activeFolderTo].folder_id;
      this.$store
        .dispatch({
          type: "moveFile",
          payload: {
            from_folder_id: fromPath,
            to_folder_id: toPath,
          },
        })
        .then((data) => {
          console.log("data: ", data);
          this.$toast.bottom(data.Msg);
          this.userFile();
          this.showMoveFile = false;
          this.showFooter = false;
          this.selectedFiles = [];
          this.isLoading = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteFile() {
      const arr = this.array.join()
      this.$store
        .dispatch({
          type:"deleteFile", 
          payload: {
            file_id: arr,
          },
        })
        .then((data) => {
          console.log("data: ", data);
          this.$toast.bottom(" file Delete ");
          this.userFile();
          this.showFileDelete = false;
          this.showFooter = false;
          this.selectedFiles = [];
          this.isLoading = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    CorfrimedDelete(value) {
      if (value) {
        const folderName = this.getUserFile.folder.map(
          (folder) => folder.folder_id
        );
        this.fileName = this.getUserFile.folder.folder_name;
        this.$store
          .dispatch({
            type: "deleteFolder",
            payload: {
              folder_id: this.getUserFile.folder[this.activeFolderindex]
                .folder_id,
              // folder_path: this.folderPath || ""
            },
          })
          .then((data) => {
            console.log("data: ", data);
            this.$toast.bottom(data.Delete);
            this.userFile();
            this.showDelete = false;
            this.showmodel = this.isSelectedIndex = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    deleteFolder(name) {
      this.activeFolderindex = name;
      this.showDelete = true;
    },

    selectFiles(index) {
      this.$set(this.selectedFiles, index, !this.selectedFiles[index]);
      this.activeFolderindex = index;
      this.downloadUrl = this.getUserFile.Data[this.activeFolderindex].data_url
      // console.log("downloadUrl",this.downloadUrl)
      // this.showFooter = true;
      // this.array.push(this.getUserFile.Data[this.activeFolderindex].data_id)
      // Download file is selected and store in array
      let boolean = false;
      this.selectedDownload.map((e) => {
        if (e == this.getUserFile.Data[this.activeFolderindex].data_url)
          boolean = true;
      });
      if (boolean) {
        this.selectedDownload.splice(index);
        // console.log("array")
      } else {
        this.selectedDownload.push(this.downloadUrl);
        // console.log("array",this.selectedDownload)
      }
      if (this.selectedDownload.length == 0) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }

      //I their file id selected and store in array
      let bool = false;
      this.array.map((e) => {
        if (e == this.getUserFile.Data[this.activeFolderindex].data_id)
          bool = true;
      });
      if (bool) {
        this.array.splice(index);
      } else {
        this.array.push(this.getUserFile.Data[this.activeFolderindex].data_id);
        // console.log("array",this.array)
      }
      if (this.array.length == 0) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    },

    redirect(value) {
      this.$store.commit("setSelectedFolder", {
        newName: value,
      });

      // this.selectedFolder = value;
      if (this.$route.params.name !== undefined)
        window.location.href += `/${value}`;
      else window.location.href += `file/${value}`;
    },
  },
};
</script>
